import Swiper from "swiper";
import { Navigation, Pagination, A11y, Grid } from "swiper/modules";
import { getCSSVar } from "./helpers";

const initAwardsSwiper = () => {
    const swiperContainer = document.querySelector(".awards__inner");
    if (!swiperContainer) return;

    let swiper;
    new ResizeObserver(() => {
        if (!swiper || swiper.destroyed) {
            swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 20,
                modules: [Navigation, Pagination, A11y, Grid],
                grid: {
                    rows: 2,
                    fill: "row",
                },
                navigation: {
                    nextEl: ".awards__nav-next",
                    prevEl: ".awards__nav-prev",
                },
                pagination: {
                    el: ".awards__pagination",
                    type: "fraction",
                },
                breakpoints: {
                    [getCSSVar("--breakpoint-md", true)]: {
                        slidesPerView: 2,
                    },
                    [getCSSVar("--breakpoint-lg", true)]: {
                        slidesPerView: 4,
                    },
                },
            });
        }
    }).observe(swiperContainer);
};

document.addEventListener("DOMContentLoaded", initAwardsSwiper);
